import { CharterStatus } from '@ankor-io/common/types/charter'

export const getStatusColour = (status: CharterStatus) => {
  switch (status) {
    case CharterStatus.IN_PROGRESS:
      return 'blue'
    case CharterStatus.COMPLETED:
      return 'green'
    case CharterStatus.UPCOMING:
      return 'gray'
    case CharterStatus.SIGNING_OFF:
      return 'orange'
    case CharterStatus.CANCELLED:
      return 'red'
    default:
      return 'gray'
  }
}

export const getStatusText = (status: CharterStatus) => {
  switch (status) {
    case CharterStatus.IN_PROGRESS:
      return 'In progress'
    case CharterStatus.COMPLETED:
      return 'Completed'
    case CharterStatus.UPCOMING:
      return 'Upcoming'
    case CharterStatus.SIGNING_OFF:
      return 'Signed off'
    case CharterStatus.CANCELLED:
      return 'Cancelled'
    default:
      return 'Upcoming'
  }
}
